export default __webpack_public_path__ + "static/media/UiBaremArrowInactive.2bb7f697.svg";